<form class="box" [formGroup]="controlForm">
  <div class="row">
    <div class="col-12">
      <div class="row p-0">

        <div class="col-12 hide-on-lg" style="
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
        ">
          <button type="button" class="btn btn--primary px-5 js-historial" routerLink="/license/show-deleted">
            Buscar licencias eliminadas
          </button>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="form">
            <label for="" class="label"> Reporte desde </label>
            <app-calendar [controlForm]="dateFromReport"></app-calendar>
            <app-error-message [text]="controlDateStartError"></app-error-message>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="form mb-0">
            <label for="" class="label"> Reporte hasta </label>
            <app-calendar [controlForm]="dateUntilReport"></app-calendar>
            <app-error-message [text]="controlDateEndError"></app-error-message>
          </div>
        </div>

        <div class="col-12 col-lg-6 hide-on-md" style="
          display: flex;
          justify-content: flex-end;
        ">
          <button type="button" class="btn btn--primary u-mt20 px-5 js-historial" routerLink="/license/show-deleted">
            Buscar licencias eliminadas
          </button>
        </div>

        <div class="col-12">
          <p class="txt txt--small mt-1">
            *Las fechas corresponden al momento en que fue generada la licencia
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 mt-2">
      <div class="row p-0">
        <div class="col-12 mb-3">
          <p class="mb-2 txt txt--paragraph txt--grey">
            <strong>Filtros de búsqueda</strong>
          </p>
          <p class="mb-2 txt txt--paragraph txt--grey">
            Selecciona las opciones en cada filtro de búsqueda para acotar los
            resultados.
          </p>
        </div>
        <div class="col-md-4 col-lg-4">
          <!-- aca va el chekbox -->

          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Asset" [itemControls]="assetsListsControl"
            [gettingItemsList]="gettingItemsList" [gettingItemsListError]="gettingItemsListError"
            [itemsList]="assetList" [listFilterAll]="listFilterAllAsset">
          </app-filter-checkbox>
        </div>
        <div class="col-md-4 col-lg-4">
          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Zona" [itemControls]="zonesListsControl"
            [gettingItemsList]="gettingZoneList" [gettingItemsListError]="gettingItemsListError" [itemsList]="zonesList"
            [listFilterAll]="listFilterAllZones">
          </app-filter-checkbox>
        </div>
        <div class="col-md-4 col-lg-4">
          <!-- aca va el chekbox -->
          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Estado licencia"
            [itemControls]="stateListsControl" [gettingItemsList]="gettingItemsList"
            [gettingItemsListError]="gettingItemsListError" [itemsList]="stateLicenseList"
            [listFilterAll]="listFilterAllState">
          </app-filter-checkbox>
        </div>
      </div>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn--primary u-mt20 px-5 js-historial"
        [attr.disabled]="controlForm.valid === true ? null : true" (click)="onGetDetailReport()">
        Ver reporte
      </button>
    </div>
  </div>
</form>
<div *ngIf="warning">
  <p class="text-warning">
    * Debe Seleccionar al menos una opción de los filtros, para obtener el
    reporte.
  </p>
</div>
<div *ngIf="gettingDetailsLicense" class="loader-wrapper">
  <div class="loader-licenses">
    <app-loader></app-loader>
  </div>
</div>
<div class="results mt-5">
  <app-report-table-licences *ngIf="detailLicenseByFilter" [detailLicenseByFilter]="detailLicenseByFilter"
    (exportToExcel)="exportToExcel()" [listCountForPages]="listCountForPages"></app-report-table-licences>

  <div class="u-mt30 d-flex justify-content-center justify-content-md-end"
    [ngClass]="{'global-unmount': !detailLicenseByFilter}">
    <div class="paginator">
      <ul>
        <li class="paginator__arrow paginator__arrow--back global-hand"
          [ngClass]="{'global-unmount': currentPage === 1}">
          <a (click)="getPreviusPage()"></a>
        </li>
        <li class="paginator__number global-hand" *ngFor="let page of listCountForPages; let i =  index"
          [ngClass]=" currentPage ===  i  + 1 ? 'paginator__number--current' :  '' ">
          <a (click)="getGotoNumberPage(i+1)">
            {{page}}
          </a>
        </li>
        <li class="paginator__arrow paginator__arrow--next global-hand"
          [ngClass]="{'global-unmount': currentPage === listCountForPages.length}">
          <a (click)=" getNextpage()"></a>
        </li>
      </ul>
    </div>
  </div>
</div>
